import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/yintai",
      component: () => import("@/yintai/view/layout/Layout"),
      children: [
        {
          path: "/yintai",
          name: "yintai",
          component: () => import("@/yintai/view/pages/HomePage.vue"),
        },
        {
          path: "/about",
          name: "about",
          component: () => import("@/yintai/view/pages/About.vue"),
        },
        {
          path: "/event",
          name: "event",
          component: () => import("@/yintai/view/pages/Event.vue"),
        },
        {
          path: "/news",
          name: "news",
          component: () => import("@/yintai/view/pages/News.vue"),
        },
        {
          path: "/news-inner",
          name: "news-inner",
          component: () => import("@/yintai/view/pages/NewsInner.vue"),
        },

        {
          path: "/contact",
          name: "contact",
          component: () => import("@/yintai/view/pages/Contact.vue"),
        },
        {
          path: "/store_inner",
          name: "consult",
          component: () => import("@/yintai/view/pages/Consult.vue"),
        },
        {
          path: "/cat",
          name: "cat",
          component: () => import("@/yintai/view/pages/Cat.vue"),
        },
        {
          path: "/store",
          name: "store",
          component: () => import("@/yintai/view/pages/Store.vue"),
        },
        {
          path: "/school",
          name: "school",
          component: () => import("@/yintai/view/pages/School.vue"),
        },
        {
          path: "/membership",
          name: "membership",
          component: () => import("@/yintai/view/pages/MemberShip.vue"),
        },
        {
          path: "/membershipStore",
          name: "membershipStore",
          component: () => import("@/yintai/view/pages/MembershipStore.vue"),
        },
        {
          path: "/cloudPicture",
          name: "cloudPicture",
          component: () => import("@/yintai/view/pages/CloudPicture.vue"),
        },
        {
          path: "/Privacy",
          name: "Privacy",
          component: () => import("@/yintai/view/pages/Privacy.vue"),
        },
        {
          path: "/Legal",
          name: "Legal",
          component: () => import("@/yintai/view/pages/Legal.vue"),
        },
      ],
    },

    {
      path: "*",
      redirect: "/yintai",
    },
  ],
});
